import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageBoxContent, MessageBoxContentTypes, MessageBoxStyle } from './message-box-content';

@Component({
  standalone: false,
  selector: 'message-box',
  templateUrl: './message-box.dialog.component.html'
})
export class MessageBoxDialogComponent {

  constructor(
    public dialogRef: MatDialogRef<MessageBoxDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: MessageBoxContent) { }

  public close(isOk?: boolean) {
    isOk = !!isOk;
    this.dialogRef.close(isOk);
  }

  public onPrimarySelected() {
    this.close(true);
    if (this.data.onPrimarySelected){
      this.data.onPrimarySelected();
    }
  }

  public onSecondarySelected() {
    this.close();
    if (this.data.onSecondarySelected){
      this.data.onSecondarySelected();
    }
  }

  public get isError() {
    return this.data.type === MessageBoxContentTypes.Error;
  }

  public get isMessage() {
    return this.data.type === MessageBoxContentTypes.Message;
  }

  public isStyleNormal() {
    return this.data.style === MessageBoxStyle.Normal;
  }

  public isStyleComplex() {
    return this.data.style === MessageBoxStyle.Complex;
  }
}
